import { render, staticRenderFns } from "./PaymentTable.vue?vue&type=template&id=2cd8300d&scoped=true"
import script from "./PaymentTable.vue?vue&type=script&lang=js"
export * from "./PaymentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd8300d",
  null
  
)

export default component.exports